export const Headspan = (props) => <span style={{color: props.color,
    fontSize: props.fontSize,
    fontStyle: "normal",
    fontWeight: props.fontWeight,
    lineHeight: "normal"}}>{props.data}</span>